module.exports = __webpack_public_path__ + "static/media/poste_15.6e5730dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_15.jpg
// module id = 243
// module chunks = 0